import { render } from "./MissChile.vue?vue&type=template&id=052cb140&scoped=true"
import script from "./MissChile.vue?vue&type=script&lang=js"
export * from "./MissChile.vue?vue&type=script&lang=js"

import "./MissChile.vue?vue&type=style&index=0&id=052cb140&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052cb140"]])

export default __exports__